"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$POST_PROMPT_;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_PROMPT_COPY = void 0;

var POST_PROMPTS = __importStar(require("./prompts"));

exports.POST_PROMPT_COPY = (_exports$POST_PROMPT_ = {}, _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.MOTIVATION, "What's your motivation for filing for bankruptcy?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.HOPES_AND_DREAMS, "What are your hopes and dreams for life without debt?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.BEFORE_BANKRUPTCY, "Before bankruptcy, what else did you try to overcome your debt?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.FRESH_START, "What changes do you plan to make to your life when you get a fresh start?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.FEELING_AFTER_FILING, "How are you feeling after filing bankruptcy?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.PLANS_REBUILD_CREDIT, "What are your plans to rebuild credit after bankruptcy?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.SAY_TO_OTHERS_CONSIDERING, "What would you say to Upsolve users considering bankruptcy?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.FEELING_341_MEETING, "What was your 341 meeting like?"), _defineProperty(_exports$POST_PROMPT_, POST_PROMPTS.BANKRUPTCY_TIMELINE, "What was your bankruptcy timeline?"), _exports$POST_PROMPT_);